import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../../constants/errorMessage'
import { Circles } from 'react-loader-spinner'

function ConfirmationModal(props) {
    const { title, showModal, setShowModal, notify, handleDispatchAction, description, resetData } = props
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async () => {
        setIsSubmitting(true)
        try {
            const result = await handleDispatchAction()
            // If handleDispatchAction returns explicitly false, do not close modal. (Allow error display.)
            if (result) {
                setTimeout(() => {
                    closeModal()
                }, 300)
            } else {
                setIsSubmitting(false)
                return
            }
        } catch (e) {
            notify('error', errorMessage?.somethingWentWrong)
            setIsSubmitting(false)
        }
    }

    const closeModal = () => {
        resetData()
        setShowModal(false)
        setIsSubmitting(false)
    }

    return (
        <>
            <Modal show={showModal} onHide={() => closeModal()} centered size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 modal-title h5 fw-bold'>{title} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {description}
                </Modal.Body>

                <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        onClick={closeModal}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary d-flex align-items-center justify-content-center"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        style={{ minWidth: '80px', minHeight: '38px', position: 'relative' }}
                    >
                        OK {isSubmitting && (
                            <span className=' ms-2'><Circles
                                height="20"
                                width="20"
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                visible={true}
                            /></span>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

ConfirmationModal.propTypes = {
    title: PropTypes.string,
    setShowModal: PropTypes.func,
    showModal: PropTypes.bool,
    notify: PropTypes.func,
    handleDispatchAction: PropTypes.func,
    description: PropTypes.node,
    resetData: PropTypes.node
}

ConfirmationModal.defaultProps = {
    title: '',
    setShowModal: noop,
    showModal: false,
    notify: noop,
    handleDispatchAction: noop,
    resetData: noop
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(ConfirmationModal)